import { useClerk } from '@clerk/clerk-react';
import { TFLoadingOverlay } from '@tf/ui';
import type React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { endClientAreaPaths } from '@/routes/endClientArea/paths';

export const SignOutRoute: React.FC = () => {
	const navigate = useNavigate();
	const { signOut } = useClerk();

	useEffect(() => {
		signOut().finally(() => {
			navigate(endClientAreaPaths.signIn());
		});
	}, [navigate, signOut]);

	return <TFLoadingOverlay />;
};
